const multiSelectStyle = {
  '.selectionBox': {
    boxSizing: 'border-box',
    minHeight: '227px',
    height: '100%',
    width: '263px',
    border: ['1px solid #ECEDEE', '1px solid black'],
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    padding: '4px 0px',
  },
  '.selectable': {
    // height: '23px',
    backgroundColor: 'transparent',
    marginTop: '5px',
  },
  '.disable': {
    pointerEvents: 'none',
    color: '#C8C9C7',
  },
  'div.selectable:hover': { backgroundColor: '#e1ecf7', cursor: 'pointer' },
  '.selected': { backgroundColor: '#006FCF', /* height: '23px', */ marginTop: '5px' },
  '.centerButtonBox': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '227px',
  },
  '.container': {
    display: 'grid',
    gridTemplateColumns: '1fr 82px 1fr',
    gridTemplateRows: 'max-content',
  },
  '.containerOrder': {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto auto',
    gridTemplateRows: 'max-content',
  },
  '.optionStyle': {
    color: '#333333',
    fontFamily: '"Helvetica Neue"',
    fontSize: '15px',
    letterSpacing: '0',
    lineHeight: '22px',
    paddingLeft: '20px',
  },
  '.centerButton': {
    paddingLeft: '27px',
    paddingRight: '27px',
    paddingTop: '27px',
  },
  '.heading': {
    height: '18px',
    color: '#333333',
    fontFamily: '"Helvetica Neue"',
    fontSize: '13px',
    fontWeight: 'bold',
    letterSpacing: '0',
    lineHeight: '18px',
    marginBottom: '15px',
    textTransform: 'uppercase',
  },
  '.disableIcon': { fill: '#C8C9C7' },
  '.enableIcon:hover': { fill: '#00175a', cursor: 'pointer' },
};

export default multiSelectStyle;
